import type { SVGProps } from 'react'
const SvgSyTechSolidCloudInference = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m3 13-.68-.27v4.64h2.13v-3.79c-.53-.17-1.02-.37-1.45-.58" />
		<path
			fillOpacity={0.24}
			d="m3.75 11 .68.27v-9H2.25v8.2c.52.15 1.02.35 1.5.53m3.92 1a7 7 0 0 0 1.09-.1V6.57H6.58v5.35a8 8 0 0 0 1.09.08"
		/>
		<path d="M7.67 14.19a10 10 0 0 1-1.09-.06v7.62h2.18v-7.62a10 10 0 0 1-1.09.06" />
		<path fillOpacity={0.24} d="M11.6 11c.48-.19 1-.39 1.48-.56v-6h-2.14v6.85c.2-.1.43-.18.66-.29" />
		<path d="M12.39 13c-.49.19-1 .39-1.49.56v6h2.18v-6.82c-.22.1-.45.19-.69.26" />
		<path fillOpacity={0.24} d="M16.33 9.84a8 8 0 0 1 1.09.07V2.25h-2.18v7.67a8 8 0 0 1 1.09-.08" />
		<path d="M16.33 12a6.6 6.6 0 0 0-1.09.09v5.28h2.18v-5.26a7 7 0 0 0-1.09-.11m3.92 1-.68-.27v9h2.18v-8.15c-.52-.17-1.01-.37-1.5-.58" />
		<path fillOpacity={0.24} d="m21.05 11 .69.27v-4.7h-2.18v3.88c.52.17 1.01.37 1.49.55" />
	</svg>
)
export default SvgSyTechSolidCloudInference
